import { cn } from "@omni/utils/styles";

import { CategoryAnchor } from "@/components/General/Sidebar/components/assortiment/components/categoryLink";
import { useCategorySlideContext } from "@/components/General/Sidebar/context/categorySlide.context";

type Props = {
    className?: string;
};

export const Header = ({ className }: Props) => {
    const { category } = useCategorySlideContext();

    return (
        <CategoryAnchor
            category={category}
            className={cn("tw:font-bold tw:py-4", className)}
        />
    );
};
